module.exports = __webpack_public_path__ + "static/media/8OLA19.10b6c9d8.jpg";